<template>
	<card width="100%" :min-height="hasContent ? 210 : 140">
		<aspect-ratio-box :ratio="4" class="absolute top-0 w-full opacity-75 bg-gray-300"/>

		<div class="w-full px-6 lg:px-8 pt-24 pb-16 border-box z-1">
			<div class="flex items-center justify-center mb-8 h-42">
				<skeleton rounded width="42" height="42"/>
			</div>
			<div class="flex flex-column items-center w-full">
				<div class="flex items-center h-32">
					<skeleton height="14" rounded/>
				</div>

				<div class="flex flex-column items-center justify-between h-32 py-4">
					<skeleton height="10" width="62" rounded/>
					<skeleton height="10" width="80" rounded/>
				</div>

				<div class="flex items-center h-28">
					<skeleton height="11" width="70" rounded/>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
export default {
	name: 'ClubCardSkeleton',

	props: {
		hasContent: {
			type: Boolean,
			default: false
		}
	}
}
</script>

